<template>
    <div class="card-styles--setting card-styles--playerstats">
        <h2>1. Detalles</h2>
        <div class="player-settings-wrap">

            

            <div class="player-setting player-setting--name">
                <label for="">nombre:</label>
                <input type="text" @blur="checkIfNameIsEmpty" v-model="cardColors.playerName">
            </div>

            <div class="player-setting player-setting--dorsal">
                <label>Dorsal:</label>
                <input type="number" max="100" step="1" v-model="cardColors.playerDorsal" @blur="checkDorsalVal(cardColors.playerDorsal)">
            </div>
            <div class="player-setting player-setting--position">
                <label>posición:</label>
                <select v-model="cardColors.playerPosition">
                    <option value="attack">Delantero</option>
                    <option value="midfield">Centrocampista</option>
                    <option value="defense">Defensa</option>
                    <option value="keeper">Portero</option>
                </select>
            </div>

        </div>

        <div class="player-settings-wrap player-settings-wrap--values">
            <div class="player-setting player-setting--attackvalue">
                <label>ataque:</label>
                <input type="number" max="100" step="1" v-model="cardColors.attackValue" @blur="checkIfSmallerThan11('attackValue')">
            </div>

            <div class="player-setting player-setting--midfieldvalue">
                <label for="">control:</label>
                <input type="number" max="100" step="1" v-model="cardColors.midfieldValue" @blur="checkIfSmallerThan11('midfieldValue')">
            </div>

            <div class="player-setting player-setting--defensevalue">
                <label>Defensa:</label>
                <input type="number" max="100" step="1" v-model="cardColors.defenseValue" @blur="checkIfSmallerThan11('defenseValue')">
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        props: ['cardColors'],
        
        methods: {
            checkIfNameIsEmpty() {
                if(this.cardColors.playerName.trim() == '' || this.cardColors.playerName.length === 1 || !/[a-zA-Z]/.test(this.cardColors.playerName)) {
                    this.cardColors.playerName = 'Nombre'
                }
            },
            checkIfSmallerThan11(valToCheck){
                // console.log(valToCheck)
                if(this.cardColors[valToCheck] > 100 || this.cardColors[valToCheck] < 0) {
                    this.cardColors[valToCheck] = 100
                }
            },

            checkDorsalVal(valToCheck) {
                if(valToCheck > 999 || valToCheck < 1) {
                    this.cardColors.playerDorsal = 17
                }
            },

            generateToplayerImg() {
                this.$emit('generateToplayerImg');
            }
        }

    }
</script>

<style lang="less">
.player-settings-wrap {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    gap: 1rem;
}

.player-setting.player-setting--name {
    flex: 3;
}

.player-setting.player-setting--position {
    flex: 1.5;
}

.player-setting.player-setting--dorsal {
    width: 75px;
}

.player-settings-wrap--values {
    & > div {
        flex: 1;
    }
}


</style>